import { BenefitsCarousel } from "@/components/home/BenefitsCarousel";
import { ExposedCouponsCarousel } from "@/components/home/ExposedCouponsCarousel";
import { ItemOffersRail } from "@/components/home/ItemOffersRail";
import ReorderLastOrderCard from "@/components/home/ReorderLastOrderCard";
import type {
  StorefrontSection,
  StorefrontSectionKey,
} from "@/domain/storefront-appearance";
import { useStorefrontAppearance } from "@/hooks/use-storefront-appearance";
import type { ReactNode } from "react";

/**
 * Who draws each home section. Exhaustive `Record` on purpose: a new contract
 * key is a compile error until someone wires it. Partial maps would let a
 * section appear in the portal and vanish silently in the storefront.
 */
const SECTION_RENDERERS: Record<
  StorefrontSectionKey,
  (section: StorefrontSection) => ReactNode
> = {
  reorder: (section) => <ReorderLastOrderCard section={section} />,
  coupons: (section) => <ExposedCouponsCarousel section={section} />,
  promotions: (section) => <ItemOffersRail section={section} />,
  featured: (section) => <ItemOffersRail section={section} />,
  bestsellers: (section) => <ItemOffersRail section={section} />,
  benefits: (section) => <BenefitsCarousel section={section} />,
};

/**
 * Configurable home sections in the MERCHANT'S ORDER. Array order only —
 * no regrouping. `visible: false` does not render at all.
 */
export function StorefrontSections() {
  const { sections } = useStorefrontAppearance();

  return (
    <>
      {sections
        .filter((section) => section.visible)
        .map((section) => (
          <div key={section.key}>{SECTION_RENDERERS[section.key](section)}</div>
        ))}
    </>
  );
}
